import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn/index";
import EmptyData from "../../Global/EmptyData";
import useCustomOffers from "./useCustomOffers";
import CreateOffer from "./CreateOffer";

const CustomOffers = () => {
  const {
    isLoading,
    isFetching,
    customOffersList,
    showEditModal,
    offerState,
    paginationOptions,
    handleEditColumnsClick,
    updateCustomOfferFields,
    handleDeleteModal,
    handleDelete,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useCustomOffers();
 
  return (
    <div>
      <HeadingGroup
        title={"Offers"}
        className={`pro-mb-4`}
        buttonTitle={customOffersList?.create_permission && "Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={offerState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: offerState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {customOffersList?.data?.data?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={customOffersList?.result || []}
            uniqueID={"id"}
            fields={customOffersList?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={<span className="material-symbols-outlined">delete</span>}
            handleSort={handleSort}
            getRow={getRow}
            clear={offerState?.clearSelection}
            loading={isFetching}
            perpage={offerState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={customOffersList?.delete_permission}
            editable={customOffersList?.edit_permission}
            showCheckBox={customOffersList?.delete_permission || customOffersList?.edit_permission}
          />
        )}

        {customOffersList?.result?.length > 0 && (
          <Pagination
            currentPage={offerState?.currentPage}
            totalPageCount={Math.ceil(
              customOffersList?.total_count / offerState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === offerState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={offerState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected Offer ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={customOffersList?.fields || []}
              moduleId={customOffersList?.module_id}
              updateData={updateCustomOfferFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={offerState?.showCreateModal}
          handleClose={handleCreateClick}
          title={
            offerState?.isEdit ? "Update Custom Offer" : "Add Custom Offer"
          }
          backdrop={"static"}
        >
          <CreateOffer closeModal={handleCreateClick} refetch={refetch} />
        </OffCanvasLayout>
      </div>
    </div>
  );
};

export default CustomOffers;
